/**
 * Get The percentage of a value on a dataset
 * @param {number} value Value to get as percentage
 * @param {number} total Total value to compare it with
 * @returns The percentage of the value based on the total
 */
export const percentageOf = (value, total) => {
    return (100 * value) / total;
};
